import { AcrobatIcon, CsvIcon, XlsxIcon } from "../../../constants/svg";

const FileIcon = ({ fileName }) => {
  const FileIconMap = {
    pdf: <AcrobatIcon />,
    xlsx: <XlsxIcon />,
    csv: <CsvIcon />,
  };

  const fileType = fileName.split(".").pop();

  if (!FileIconMap[fileType]) {
    return null;
  }

  return <div>{FileIconMap[fileType]}</div>;
};

export default FileIcon;
